<template>
  <form @submit.prevent="aplicar">
    <div class="form-group">
      <div class="input-group mr-1">
        <label for="anio_actual">Año Anterior</label>
        <select required v-model="filtros.anio_anterior" class="pointer" name="ano" id="anio_anterior">
          <option value="">Seleccione año...</option>
          <option v-for="item in years(2015, 10)" :value="item">{{item}}</option>
        </select>
        <i class="bar"></i>
      </div>
      <div class="input-group mr-1">
        <label for="anio_actual">Año Actual</label>
        <select required @change="getLastYear" v-model="filtros.anio_actual" class="pointer" name="ano"
                id="anio_actual">
          <option value="">Seleccione año...</option>
          <option v-for="item in years(2015, 10)" :value="item">{{item}}</option>
        </select>
        <i class="bar"></i>
      </div>
      <div class="input-group mr-1">
        <label for="sucursal">Sucursal</label>
        <select required v-model="filtros.sucursal" class="pointer" name="sucursal" id="sucursal">
          <option value="">Seleccione sucursal...</option>
          <option v-for="item in $store.getters.sucursales" :value="item">{{item.nombre}}</option>
        </select>
        <i class="bar"></i>
      </div>

    </div>
    <button class="btn btn-micro btn-warning mt-0 ml-0 mt-0 mb-4" type="submit">Aplicar</button>
  </form>
</template>

<script>
  import {years} from "../js/months";

  export default {
    name: "filtrosVentasAnual",
    mounted() {
      if (this.$route.params.data) {
        const {data} = this.$route.params
        this.filtros.anio_actual = parseInt(data.anio)
        this.filtros.anio_anterior = parseInt(data.anio_anterior)
        this.filtros.sucursal = this.$store.getters.sucursal(data.sucursal_id)
        this.aplicar()
      }
    },
    created() {
      this.$store.dispatch('loadSucursal')
      this.filtros.anio_actual = new Date().getFullYear()
      this.getLastYear()
    },
    methods: {
      aplicar() {
        this.$emit('aplicarFiltro', this.filtros)
      },
      getLastYear() {
        if (this.filtros.anio_actual === 2015) this.filtros.anio_anterior = 2015
        else this.filtros.anio_anterior = parseInt(this.filtros.anio_actual) - 1
      }
    },
    data() {
      return {
        filtros: {
          anio_actual: "",
          anio_anterior: "",
          sucursal: ""
        },
        years
      }
    }
  }
</script>

<style scoped>

</style>
